export const TOGGLE_ANNOUNCEMENTS = 'TOGGLE_ANNOUNCEMENTS';

export function toggleAnnouncements() {
  return {
    type: TOGGLE_ANNOUNCEMENTS,
  };
};
